import { ProdEnvironment } from "./prod.env";
import { DevEnvironment } from "./dev.env";
import { StageEnvironment } from "./staging.env";
import { DemoEnvironment } from "./demo.env";

export interface Environment {
  base_url: string;
  send_email_url:string;
  send_onyx_email_url?:string;
}

export function getEnvVariable() {
  switch (process.env.NODE_ENV as any) {
    case "production":
      return ProdEnvironment;
    case "test":
      return StageEnvironment;
      case "staging":
          return StageEnvironment;
      case "demo":
          return DemoEnvironment;
    default:
      return DevEnvironment;
  }
}
